module.exports = __webpack_public_path__ + "img/project-historic.664dcbd2.png";